var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/Dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2366",
    d: "M16.2929 11.7071C16.9229 11.0771 16.4767 10 15.5858 10H8.41421C7.52331 10 7.07714 11.0771 7.70711 11.7071L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929L16.2929 11.7071Z",
    fill: "#0A0D14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownCu);
export default __webpack_public_path__ + "static/media/icon-dropdown-cu.336eb6becc687c99c70f66aa66430022.svg";
export { ForwardRef as ReactComponent };